// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/3503c653/" + chunkId + "." + __webpack_require__.h() + ".v3503c653.js";
};